import {findParentNode} from "prosemirror-utils";
import {schema} from "../module/config/schema";
import {NodeType} from "prosemirror-model";
import {EditorState} from "prosemirror-state";

const getListAncestorFromSelection = findParentNode(node => node.type === schema.nodes.list)
export const isListActive = (
    type: NodeType,
    listType: string
) => (state: EditorState): boolean => {
    const parentList = getListAncestorFromSelection(state.selection);
    if (!parentList) {
        return false;
    }
    return parentList.node.attrs.type === listType;
}
